// ===========================================================
// ERP CUSTOMERS MODULE
// ===========================================================

function renderCustomersUI(){
  const target = document.getElementById('customers-target');
  if(!target) return;
  
  window.toggleLoader(true);
  
  const all = UI_DATA.customers || [];
  if(!all.length){
    target.innerHTML = '<div style="padding:40px;text-align:center">No Customers Found</div>';
    window.toggleLoader(false);
    return;
  }
  
  const start = (CURRENT_PAGE.customers - 1) * PAGE_SIZE;
  const pageCust = all.slice(start, start + PAGE_SIZE);
  
  target.innerHTML = `
    <div class="product-card">
      <table class="enterprise-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Phone</th>
            <th>Email</th>
            <th>Orders</th>
            <th>Total Spent</th>
          </tr>
        </thead>
        <tbody>
          ${pageCust.map(c => {
            const phone = c.phone || (c.default_address ? c.default_address.phone : 'N/A');
            return `
              <tr>
                <td>
                  <b>${c.first_name || ''} ${c.last_name || ''}</b>
                  ${c.verified_email ? '✓' : ''}
                </td>
                <td>${phone}</td>
                <td>${c.email || 'N/A'}</td>
                <td>${c.orders_count || 0}</td>
                <td><b>${formatPrice(c.total_spent || 0)}</b></td>
              </tr>`;
          }).join('')}
        </tbody>
      </table>
      <div id="customers-pagination-holder"></div>
    </div>`;
  
  setTimeout(() => renderPaginationUI('customers', all.length, CURRENT_PAGE.customers), 100);
  window.toggleLoader(false);
}

// Process Customers Search
window.processCustomers = () => {
  const q = document.getElementById('cust-search')?.value.trim().toLowerCase() || '';
  
  UI_DATA.customers = MASTER_DB.customers.filter(c => {
    const matchName = (c.first_name + ' ' + c.last_name).toLowerCase().includes(q);
    const matchEmail = c.email?.toLowerCase().includes(q);
    const matchPhone = c.phone?.includes(q);
    return matchName || matchEmail || matchPhone;
  });
  
  CURRENT_PAGE.customers = 1;
  renderCustomersUI();
};